import { get } from "./api";
import { Settings } from "../models/Settings";
import { ok, Result } from "../result";
import { ProblemDetails } from "../models/Http";

export const getSettings = async (): Promise<
  Result<ProblemDetails, Settings>
> => {
  const response = await get("/settings");

  if (response.ok) {
    const content = await response.json();
    return ok(content.value);
  }

  return Promise.reject({
    reason: "NOTFOUND"
  });
};
